export function date (string, simple = false) {
    const date = new Date(string);
    if (isNaN(date.getTime())) return '';
    return simple ? date.getFullYear() + '/' + (date.getMonth() + 1) :
        `${date.getFullYear()}年${date.getMonth() + 1}月`
}

export function price (number, precision) {
    number = Math.floor(number);
    let result = '';
    const oku = Math.floor(number / 100000000);
    if (oku) result += oku + '億';
    number %= 100000000;
    const man = Math.floor(number / 10000);
    if (man) result += man + '万';
    if (precision) {
        const factor = 10 ** precision;
        result += Math.floor(number / factor) * factor % 10000 || '';
    }
    return result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function address (string) {
    return string.replace(/(県|都|府|道|市|区|郡|町|丁目|村|番地)/g, '$1\n');
}
